import { FunctionComponent, useEffect, useState } from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import {
  payment_request_default,
  PaymentModeOptions,
  PaymentRequestModel,
  po_payments_req_status,
} from "../../model/payment_request_model";
import { urls } from "../../../../utils/urls";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import { fetchGet, fetchPost, fetchPut } from "../../../../service/api_client";
import LoadingWidget from "../../../../context_providers/modal/loader";
import moment from "moment";
import AttachmentViewer from "../../../../ui/new_components/common/attachment_viewer";
import { POType, PurchaseOrderModelV2 } from "../../model/purchase_order_model";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiHistory, mdiInformationOutline } from "@mdi/js";
import { currencyFormat } from "../../../../utils/currency_format";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../../ui/new_components/common/drawer_modal";
import {
  getProcurementAttachmentPRESignedURL,
  postProcurementAttachmentS3,
  updatePaymentRequestApi,
} from "../../purchase_order_create/service/purchase_order_repository";
import ActionHistoryAdvance from "../components/payment_request_advance_history_logs";
import {
  ModalAlignment,
  ModalType,
  useModal,
} from "../../../../context_providers/modal/modal_context";
import { POLineItemCard } from "../../purchase_order_create/components/po_line_item_card";
import { usePurchaseOrder } from "../../contexts/po-creation-context";
import { currencies } from "../../../accounts/models/party_model";
import { Project } from "../../../inventory/models/project_model";
import ModalDialog from "../../../../ui/new_components/common/modal";
import { useAuth } from "../../../../context_providers/auth/authProvider";
import { ACTION, MODULE } from "../../../../utils/enums";
import { StatusBadge } from "../../../../ui/new_components/common/responsive";

interface PaymentRequestAdvanceViewProps {}

const fmtDate = (d?: any) => (d ? moment(d).format("DD-MM-YYYY") : "--");

const ReadField: FunctionComponent<{
  label: string;
  value?: any;
  valueClassName?: string;
  className?: string;
}> = ({ label, value, valueClassName, className }) => (
  <div className={`flex flex-col ${className ?? ""}`}>
    <span className="text-gray-400">{label}</span>
    <span
      className={`font-semibold break-words ${
        valueClassName ?? "text-gray-700"
      }`}
    >
      {value === undefined || value === null || value === "" ? "--" : value}
    </span>
  </div>
);

const PaymentRequestAdvanceScreen: FunctionComponent<
  PaymentRequestAdvanceViewProps
> = () => {
  const isUpdatePage = useRouteMatch(
    `${urls.po_advance_payment_request}/updateAdvance/:id`,
  );
  const { id } = useParams<{ id: string }>();
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/advance_payment_request`;
  const [showSuccess, setShowSuccess] = useState(false);
  const [percent, setPercent] = useState<number>(0);
  const [amountAdvance, setAmount] = useState<any>();
  const [payAmount, setPayAmount] = useState<number>(0);
  const { showToast } = useToast();
  const [showCreatePaymentRequestModal, setShowCreatePaymentRequestModal] =
    useState(false);
  const [
    showAdvancePaymentRequestWithdrawModal,
    setShowAdvancePaymentRequestWithdrawModal,
  ] = useState(false);
  const [advancePaymentFileList, setAdvancePaymentFileList] = useState<File[]>(
    [],
  );
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  // const { edit } = props;
  const [project, setProject] = useState<Project>();
  // const [purchaseOrder, setpurchaseOrder] =
  //   useState<PurchaseOrderModelV2>();
  const { purchaseOrder, setPurchaseOrder, defaultProject, setDefaultProject } =
    usePurchaseOrder();
  const [data, setData] = useState<PaymentRequestModel>(
    payment_request_default || ({} as PaymentRequestModel),
  );
  const existingItems = purchaseOrder?.items || [];

  const defaultPaymentRequestModel: PaymentRequestModel =
    payment_request_default;
  const [procuremntRead, setProcurementRead] = useState(false);
  const { user, isAuthorised } = useAuth();
  useEffect(() => {
    const procuremnt_read_only = isAuthorised({
      module: MODULE.procurement_read_only,
      action: ACTION.READ,
    });

    setProcurementRead(procuremnt_read_only);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorised]);
  const { showModal } = useModal();

  useEffect(() => {
    // Fetch the data for the payment request (when editing or creating)
    if (id && isUpdatePage) {
      getData(id);
      // console.log("Updated amountAdvance:", amountAdvance);
    }
  }, [data.id]);

  useEffect(() => {
    const fetchPurchaseOrder = async () => {
      if (data.po_no) {
        await fetchPurchaseOrderByPoNo(data.po_no);
      }
    };

    fetchPurchaseOrder();
  }, [data.po_no]);
  // Assuming res.data is a single PurchaseOrderModel
  console.log("purchaseOrder:", purchaseOrder);
  useEffect(() => {
    const fetchProjectData = async () => {
      if (purchaseOrder?.project_id && !project) {
        await getProjectData(purchaseOrder.project_id);
      }
    };

    fetchProjectData();
  }, [purchaseOrder?.project_id, project]);

  const submit = async () => {
    try {
      console.log(data);
      if (!data.payment_amount) {
        showToast({
          type: ToastType.error,
          text: "Please fill all the required details",
        });
        return;
      }

      setLoading(true);

      const res = data.id
        ? await fetchPut(`${url}/${data.id}`, data)
        : await fetchPost(url, data);

      console.log({ res });
      if (res.success) {
        showToast({ type: ToastType.success, text: res.message });
        if (!data.id) {
          setData(defaultPaymentRequestModel);
          setShowSuccess(true);
        }
        setData((prevData) => ({
          ...prevData,
          ...res.data, // Update with the response data
        }));
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      showToast({ type: ToastType.error, text: "An error occurred" });
    } finally {
      setLoading(false);
    }
  };

  const PRStatus = async (status: string) => {
    if (status) {
      try {
        const res = await fetchPut(`${url}/${data.id}/payment_approval`, data);

        console.log("API response:", res); // Log the full response for debugging
        showToast({
          type: ToastType.success,
          text: "PR Status Updated.",
        });
        history.push(urls.po_payment_request_approval);
        // Your existing success/error logic...
      } catch (error) {
        console.error("Error while updating payment status:", error);
        showToast({
          type: ToastType.error,
          text: "Failed to update status. Try again later.",
        });
      }
    }
  };

  const handlePercentageChange = (e: any) => {
    const percentage = Number(e.target.value);

    // Update state immediately for responsive input
    setData((prev) => ({
      ...prev,
      payment_amount: 0,
      percentage: percentage,
    }));

    // Trigger validation and API logic
    getPaymentAmount(percentage);
  };

  const getPaymentAmount = async (percentage: number) => {
    if (percentage < 0) {
      showToast({
        type: ToastType.error,
        text: "Please enter a valid percentage.",
      });
      return;
    }

    try {
      // Fetch the current total percentage from the backend
      const res = await fetchGet(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/advance_payment_request/get-percentage/${data.po_no}`,
      );
      const po_total =
        (purchaseOrder?.subtotal ?? 0) +
          (purchaseOrder?.cgst ?? 0) +
          (purchaseOrder?.sgst ?? 0) +
          (purchaseOrder?.igst ?? 0) || 0;

      if (res.success) {
        const calculatedPercentage = purchaseOrder
          ? ((res.totalAmount - payAmount) / po_total) * 100
          : 0;
        const availablePercentage = 100 - calculatedPercentage;
        setPercent(availablePercentage);
        if (percentage > availablePercentage) {
          showToast({
            type: ToastType.error,
            text: `Percentage exceeds available limit. Available: ${availablePercentage}%`,
          });
          return;
        }
        // const availablePercent = 100 - totalPercentageUsed;
        const calculatedAmount = purchaseOrder
          ? (percentage * po_total) / 100
          : 0;

        if (calculatedAmount > (po_total ?? 0)) {
          showToast({
            type: ToastType.error,
            text: "Amount should not be greater than total amount.",
          });
          return;
        }

        // Update the payment amount in the state
        setData((prev) => ({
          ...prev,
          payment_amount: calculatedAmount,
        }));
      } else {
        showToast({
          type: ToastType.error,
          text: res.message || "Failed to fetch percentage data.",
        });
      }
    } catch (error: any) {
      console.error("Error fetching percentage:", error);
      showToast({
        type: ToastType.error,
        text: error.message || "An unexpected error occurred.",
      });
    }
  };

  const handleAmountChange = (e: any) => {
    const amount = Number(e.target.value);

    // Update state immediately for responsive input
    setData((prev) => ({
      ...prev,
      payment_amount: amount,
      percentage: 0,
    }));

    // Trigger validation and API logic
    getPercentage(amount);
  };

  const getPercentage = async (amount: number) => {
    if (amount < 0) {
      showToast({
        type: ToastType.error,
        text: "Amount cannot be negative.",
      });
      return;
    }

    try {
      const res = await fetchGet(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/advance_payment_request/get-percentage/${data.po_no}`,
      );
      if (res.success) {
        const totalAmount = res.totalAmount || 0;
        const po_total =
          (purchaseOrder?.subtotal ?? 0) +
            (purchaseOrder?.cgst ?? 0) +
            (purchaseOrder?.sgst ?? 0) +
            (purchaseOrder?.igst ?? 0) || 0;

        const availableAmount = po_total - totalAmount + payAmount;
        // to include this pr pay amount as well in updated amount.
        setAmount(availableAmount);
        if (amount > availableAmount) {
          showToast({
            type: ToastType.error,
            text: `Amount exceeds available limit. Available: ${availableAmount}.`,
          });
          return;
        }
        const calculatedPercentage = purchaseOrder
          ? (amount / (po_total || 1)) * 100
          : 0;

        if (calculatedPercentage > 100) {
          showToast({
            type: ToastType.error,
            text: "Calculated percentage exceeds 100%.",
          });
          return;
        }

        setData((prev) => ({
          ...prev,
          percentage: calculatedPercentage,
        }));
      } else {
        showToast({
          type: ToastType.error,
          text: res.message || "Failed to fetch amount data.",
        });
      }
    } catch (error: any) {
      console.error("Error fetching amount:", error);
      showToast({
        type: ToastType.error,
        text: error.message || "An unexpected error occurred.",
      });
    }
  };

  const fetchPurchaseOrderByPoNo = async (
    poNo: string,
  ): Promise<PurchaseOrderModelV2 | null> => {
    try {
      const res = await fetchGet(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${poNo}`,
      );
      if (res.success) {
        if (!res.data.vendor_currency) {
          res.data.vendor_currency = currencies.rupee;
          res.data.vendor_currency_to_inr = 1;
        }

        if (res.data.items === undefined || res.data.items === null) {
          res.data.items = [];
        }

        setPurchaseOrder({ ...res.data });
        if (res.data.items[0].project) {
          setDefaultProject(res.data.items[0].project);
        }

        return res.data as PurchaseOrderModelV2;
      } else {
        showToast({ type: ToastType.error, text: res.error });
        return null;
      }
    } catch (error) {
      showToast({ type: ToastType.error, text: (error as Error).message });
      return null;
    }
  };

  const handleCancelPaymentRequest = async () => {
    resetForm();
  };

  const handleUpdatePaymentRequest = async (e: any) => {
    e.preventDefault(); // Prevent form submission and page reload
    // console.log("data.payment_amount",data.payment_amount)
    await getPercentage(data.payment_amount);
    if (
      data.pr_status === "Approved" ||
      data.pr_status === "Rejected" ||
      data.pr_status === po_payments_req_status.withdrawn
    ) {
      showToast({
        type: ToastType.error,
        text: "The Approved/Rejected PR is not editable!!",
      });
      handleCancelPaymentRequest();
      return;
    }
    if (amountAdvance < data.payment_amount) {
      showToast({
        type: ToastType.error,
        text:
          "Amount should not be greater than total amount: " + amountAdvance,
      });
      return;
    }
    // Validate if payment amount and due date are provided
    if (!data.payment_amount || !data.percentage || !data.due_date) {
      showToast({
        type: ToastType.error,
        text: "Please enter all values!",
      });
      return;
    }
    if ((data?.pi_amount ?? 0) > 0) {
      if ((data?.pi_amount ?? 0) < data?.payment_amount) {
        showToast({
          type: ToastType.error,
          text: "Payment amount cannot be more than Invoice amount.",
        });
        return;
      }
    }

    setLoading(true); // Start loading indicator

    try {
      // Get pre-signed URLs for file uploads
      const pre_signed_url_list = await getProcurementAttachmentPRESignedURL(
        advancePaymentFileList,
      );
      if (!pre_signed_url_list) {
        showToast({
          type: ToastType.error,
          text: "Error in getting signed URL",
        });
        setLoading(false); // Stop loading on error
        return;
      }

      // Iterate over each file and upload it
      for (let i = 0; i < pre_signed_url_list.length; i++) {
        const [signed_url, file, attachment] = pre_signed_url_list[i];
        const res = await postProcurementAttachmentS3(
          signed_url,
          file,
          attachment,
        );
        if (!res) {
          showToast({
            type: ToastType.error,
            text: "Error in uploading attachments",
          });
          setLoading(false); // Stop loading on upload failure
          return;
        }
      }

      // Add new attachments to the state
      const newAttachments = pre_signed_url_list.map(
        ([, , attachment]) => attachment,
      );
      const updatedState = {
        ...data,
        attachments: [...data.attachments, ...newAttachments],
      };

      // Call the API to create the Advance Payment Request
      const create_payment_request_advance_payment_res =
        await updatePaymentRequestApi(updatedState.id, updatedState);
      setData(updatedState); // Update state with the new data

      if (create_payment_request_advance_payment_res.success) {
        showToast({
          type: ToastType.success,
          text: create_payment_request_advance_payment_res.message,
        });
      } else {
        showToast({
          type: ToastType.error,
          text: create_payment_request_advance_payment_res.error,
        });
      }
    } catch (error: any) {
      // Handle unexpected errors
      console.error(
        "Error in uploading attachments or creating payment request",
        error,
      );
      showToast({
        type: ToastType.error,
        text: error.message || "An unexpected error occurred",
      });
    } finally {
      // Ensure loading is stopped regardless of success or failure
      setLoading(false);
      setShowCreatePaymentRequestModal(false); // Close modal after processing
    }
  };

  const getProjectData = async (id: string) => {
    setLoading(true);

    const res = await fetchGet(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/project/${id}`,
    );
    if (res.success) {
      setProject({ ...res.data });
    } else showToast({ type: ToastType.error, text: res.error });
    setLoading(false);
  };

  const showLog = () => {
    showModal({
      title: "Logs",
      type: ModalType.drawer,
      alignment: ModalAlignment.right,
      container: (id) => <ActionHistoryAdvance pr_id={data.id} data={data} />,
    });
  };

  const getData = async (id: string) => {
    try {
      setLoading(true);
      console.log("id:", id);
      const res = await fetchGet(`${url}/${id}`);
      if (res.success) {
        const updatedData = { ...res.data, type: res.data.type }; // Update type property if necessary
        setData(updatedData); // Update state with merged data
        setPayAmount(updatedData.payment_amount);
      } else {
        console.log("Invalid");
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error) {
      showToast({ type: ToastType.error, text: "An error occurred" });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setData(payment_request_default);
    setShowCreatePaymentRequestModal(false);
  };

  return (
    <>
      {showAdvancePaymentRequestWithdrawModal && (
        <ModalDialog
          id="payment_request_advance_view_withdraw_modal"
          show={showAdvancePaymentRequestWithdrawModal}
          title={"Invoice Payment Request Withrawal"}
          onClose={() => {
            setShowAdvancePaymentRequestWithdrawModal(false);
            setData({
              ...data,
              pr_status: po_payments_req_status.pending,
            });
          }}
        >
          <div className="bg-white p-4 sm:p-6 rounded-md shadow-lg w-full sm:w-96">
            <h2 className="text-md font-semibold mb-4">
              Are yous sure to withdraw the Payment Request?
            </h2>
            <div className="flex justify-between mt-4">
              <button
                id="payment_request_advance_view_withdraw_cancel_btn"
                onClick={() => {
                  setShowAdvancePaymentRequestWithdrawModal(false);
                  setData({
                    ...data,
                    pr_status: po_payments_req_status.pending,
                  });
                }}
                className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-700"
              >
                No
              </button>
              <button
                id="payment_request_advance_view_withdraw_confirm_btn"
                onClick={() => {
                  PRStatus(po_payments_req_status.withdrawn);
                }}
                className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
              >
                Yes
              </button>
            </div>
          </div>
        </ModalDialog>
      )}
      {showCreatePaymentRequestModal && (
        <DrawerModal
          id="payment_request_advance_view_update_drawer"
          show={showCreatePaymentRequestModal}
          title={"Update Payment Request"}
          onClose={resetForm}
          location={DrawerModalLoaction.right} // or whatever location you are using for the DrawerModal
        >
          <div className="flex flex-col gap-3 w-auto h-auto p-5">
            {/* Render form based on selected payment type */}
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-5 w-auto">
                {/* First Row */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 w-full">
                  <div className="flex flex-col gap-1 w-full">
                    <label htmlFor="" className="text-xs text-gray-500">
                      Percentage
                    </label>
                    <input
                      id="payment_request_advance_view_percentage"
                      type="number"
                      className="border px-2 py-1 rounded-md w-full"
                      value={data.percentage}
                      onChange={handlePercentageChange}
                      // onChange={(e) =>
                      //   setPaymentRequestAdvance({
                      //     ...paymentRequestAdvance,
                      //     percentage: Number(e.target.value),
                      //   })
                      // }
                    />
                    <span className="font-light">
                      Available Percent is:{percent}
                    </span>
                  </div>
                  <div className="flex flex-col gap-1 w-full">
                    <label htmlFor="" className="text-xs text-gray-500">
                      Payment Amount
                    </label>
                    <input
                      id="payment_request_advance_view_payment_amount"
                      type="number"
                      className="border px-2 py-1 rounded-md w-full"
                      value={data.payment_amount || ""}
                      onChange={handleAmountChange}
                      // disabled={paymentRequestAdvance.percentage !== undefined}
                    />
                    <span className="font-light">
                      Available amount is:{amountAdvance}
                    </span>
                  </div>
                </div>

                {/* Second Row */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 w-full">
                  <div className="flex flex-col gap-1 w-full">
                    <label htmlFor="" className="text-xs text-gray-500">
                      Due Date
                    </label>
                    <input
                      id="payment_request_advance_view_due_date"
                      type="date"
                      value={
                        data?.due_date
                          ? moment(data?.due_date).format("YYYY-MM-DD") // Format to YYYY-MM-DD for input
                          : "" // Empty by default, so no date is selected initially
                      }
                      min={moment().format("YYYY-MM-DD")} // Prevent selection of past dates
                      className="w-full px-3 py-2 border rounded-md"
                      onChange={(e) => {
                        const selectedDate = e.target.value; // Get the selected date string (YYYY-MM-DD)
                        const date = selectedDate
                          ? new Date(
                              new Date(selectedDate).setHours(0, 0, 0, 0),
                            ) // Set the time to 00:00:00
                          : undefined; // If no date is selected, reset the value

                        // Update the state with the selected date
                        setData((pv) => ({
                          ...pv,
                          due_date: date!, // Save the selected date in state
                        }));
                      }}
                    />
                  </div>
                  <div className="flex flex-col gap-1 w-full">
                    <label htmlFor="" className="text-xs text-gray-500">
                      PI Number
                    </label>
                    <input
                      id="payment_request_advance_view_pi_no"
                      type="text"
                      className="border px-2 py-1 rounded-md w-full"
                      value={data.pi_no}
                      onChange={(e) =>
                        setData({
                          ...data,
                          pi_no: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* Third Row */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 w-full">
                  <div className="flex flex-col gap-1 w-full">
                    <label htmlFor="" className="text-xs text-gray-500">
                      PI Date
                    </label>
                    <input
                      id="payment_request_advance_view_pi_date"
                      type="date"
                      className="border px-7 py-1 rounded-md w-full"
                      value={
                        data?.pi_date
                          ? moment(data?.pi_date).format("YYYY-MM-DD")
                          : ""
                      }
                      onChange={(e) => {
                        const selectedDate = e.target.value; // Get the selected date string (YYYY-MM-DD)
                        const date = selectedDate
                          ? new Date(
                              new Date(selectedDate).setHours(0, 0, 0, 0),
                            ) // Convert to a date object
                          : undefined; // Reset if no date is selected

                        // Update the paymentRequest state with the selected date
                        setData((pv) => ({
                          ...pv,
                          pi_date: date!, // Save the selected date in state
                        }));
                      }}
                    />
                  </div>
                  <div className="flex flex-col gap-1 w-full">
                    <label htmlFor="" className="text-xs text-gray-500">
                      PI Amount
                    </label>
                    <input
                      id="payment_request_advance_view_pi_amount"
                      type="number"
                      className="border px-2 py-1 rounded-md w-full"
                      value={data.pi_amount}
                      onChange={(e) =>
                        setData({
                          ...data,
                          pi_amount: +e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-1 w-full">
                <label htmlFor="" className="text-xs text-gray-500">
                  Payment Mode
                </label>
                <select
                  id="payment_request_advance_view_payment_mode"
                  className="border px-2 py-1 rounded-md w-full"
                  value={data.payment_mode} // Ensure default is "raw_material"
                  onChange={(e) =>
                    setData({
                      ...data,
                      payment_mode: e.target.value,
                    })
                  }
                >
                  <option value="" hidden>
                    Select
                  </option>
                  {Object.values(PaymentModeOptions).map((c, i) => (
                    <option value={c} key={i}>
                      {c}
                    </option>
                  ))}
                  {/* <option value="Bank Transfer">Bank Transfer</option>
                  <option value="Credit Card">Credit Card</option>
                  <option value="Petty Cash">Petty Cash</option> */}
                  {/* Add more options as needed */}
                </select>
              </div>

              {/* Attach Files Section */}

              <div className="flex flex-col gap-1">
                <label htmlFor="" className="text-xs text-gray-500">
                  Attach Files
                </label>

                <input
                  id="payment_request_advance_view_attachment_file_input"
                  type="file"
                  multiple
                  className="border px-2 py-1 rounded-md"
                  onChange={(e) => {
                    if (e.target.files) {
                      const newFiles = Array.from(e.target.files);
                      console.log(newFiles);
                      setAdvancePaymentFileList((prevFiles) => [
                        ...prevFiles,
                        ...newFiles,
                      ]);
                      console.log(
                        "advance payment fileList",
                        advancePaymentFileList,
                      );
                    }
                  }}
                />

                <div className="w-full mt-2 mx-auto">
                  {/* Render previously uploaded files (data.attachments) */}
                  {data.attachments?.length > 0 && (
                    <div>
                      <h4 className="text-sm font-semibold mb-2">
                        Previous Attachments:
                      </h4>
                      {data.attachments.map((attachment, index) => (
                        <ul
                          key={index}
                          className="py-2 m-2 flex justify-around rounded-md text-black border-2"
                        >
                          <div>
                            <li className="flex items-center gap-2">
                              {/* Check for file type and render accordingly */}
                              {attachment?.type === "Image" ||
                              attachment?.type === "CSV" ? (
                                <img
                                  src={attachment?.url} // Using signed URL for image
                                  alt="Attachment preview"
                                  className="w-16 h-16 object-cover"
                                />
                              ) : attachment?.type === "application/pdf" ? (
                                <embed
                                  src={attachment.url} // Using signed URL for PDF preview
                                  type="application/pdf"
                                  className="w-16 h-16"
                                />
                              ) : (
                                <span>{attachment.url}</span> // For other file types, display the file name or URL
                              )}
                            </li>
                          </div>

                          <div>
                            <button
                              id={`payment_request_advance_view_attachment_${index}_remove_btn`}
                              type="button"
                              className="text-red-500"
                              onClick={() => {
                                // Handle removal of the previous attachment
                                const updatedAttachments =
                                  data.attachments.filter(
                                    (_, i) => i !== index,
                                  );
                                setData({
                                  ...data,
                                  attachments: updatedAttachments, // Update the data state with the new list
                                });
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        </ul>
                      ))}
                    </div>
                  )}

                  {/* Render newly selected files (advancePaymentFileList) */}
                  {advancePaymentFileList.length > 0 && (
                    <div>
                      <h4 className="text-sm font-semibold mb-2">
                        Newly Selected Files:
                      </h4>
                      {advancePaymentFileList.map((file, index) => (
                        <ul
                          key={index}
                          className="py-2 m-2 flex justify-around rounded-md text-black border-2"
                        >
                          <div>
                            <li className="flex items-center gap-2">
                              {/* Check for file type and render accordingly */}
                              {file.type.startsWith("image") ? (
                                <img
                                  src={URL.createObjectURL(file)} // Using object URL for image preview
                                  alt={file.name}
                                  className="w-16 h-16 object-cover"
                                />
                              ) : file.type === "pdf" ? (
                                <embed
                                  src={URL.createObjectURL(file)} // Using object URL for PDF preview
                                  type="application/pdf"
                                  className="w-16 h-16"
                                />
                              ) : file.type === "csv" ? (
                                <embed
                                  src={URL.createObjectURL(file)} // Using object URL for PDF preview
                                  type="CSV"
                                  className="w-16 h-16"
                                />
                              ) : (
                                <span>{file.name}</span> // For other file types, display the file name
                              )}
                            </li>
                          </div>
                          <div>
                            <button
                              id={`payment_request_advance_view_new_file_${index}_remove_btn`}
                              type="button"
                              className="text-red-500"
                              onClick={() => {
                                // Handle removal of the newly selected attachment
                                setAdvancePaymentFileList((prevFiles) =>
                                  prevFiles.filter(
                                    (_, currIndex) => currIndex !== index,
                                  ),
                                );
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        </ul>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Additional Notes Text Area */}
              <div className="flex flex-col gap-1">
                <label htmlFor="" className="text-xs text-gray-500">
                  Additional Notes
                </label>
                <textarea
                  id="payment_request_advance_view_notes"
                  className="border px-2 py-1 rounded-md"
                  value={data.notes}
                  onChange={(e) =>
                    setData({
                      ...data,
                      notes: e.target.value,
                    })
                  }
                  placeholder="Enter any additional notes here"
                />
              </div>
            </div>

            <div className="flex flex-row gap-3 mt-5">
              <button
                id="payment_request_advance_view_update_cancel_btn"
                onClick={handleCancelPaymentRequest}
                className="flex-1 bg-white py-2 rounded-md text-black border-2"
              >
                Cancel
              </button>
              <button
                id="payment_request_advance_view_update_submit_btn"
                onClick={handleUpdatePaymentRequest}
                className="flex-1 bg-myPrimaryColor py-2 rounded-md text-white border-2"
              >
                Update
              </button>
            </div>
          </div>
        </DrawerModal>
      )}
      {/* <div className="flex items-center justify-between mb-2 py-2 px-6">
        <div className="text-xl font-bold border-l-4 border-myPrimaryColor pl-2">
          Payment Request <span className="text-sm">#{data.id}</span>
        </div>
      </div> */}
      <div className="sticky top-0 z-20 bg-myBgcolor px-3 sm:px-5 py-2">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-2 min-w-0">
            <button
              id="payment_request_advance_view_back_btn"
              className="flex items-center hover:text-gray-700 font-semibold text-sm shrink-0"
              onClick={() => {
                history.goBack();
              }}
            >
              <Icon path={mdiChevronLeft} className="h-5 w-5" /> Back
            </button>
            <div className="text-base sm:text-xl font-bold border-l-4 border-myPrimaryColor pl-2 truncate">
              Advance Payment Request{" "}
              <span className="text-xs sm:text-sm font-semibold text-gray-500">
                #{data.id}
              </span>
            </div>
          </div>
          {data.id && (
            <button
              id="payment_request_advance_view_history_btn"
              title="Logs"
              onClick={showLog}
              className="rounded-full p-2 hover:scale-105 transform duration-150 bg-myPrimaryColor text-white shadow cursor-pointer flex items-center justify-center shrink-0"
            >
              <Icon path={mdiHistory} className="h-5 w-5" />
            </button>
          )}
        </div>
        {(data.pr_status || data.payment_status) && (
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2">
            {data.pr_status && (
              <span className="flex items-center gap-1 text-xs text-gray-500">
                PR Status
                <StatusBadge status={data.pr_status} kind="generic" />
              </span>
            )}
            {data.payment_status && (
              <span className="flex items-center gap-1 text-xs text-gray-500">
                Payment
                <StatusBadge status={data.payment_status} kind="generic" />
              </span>
            )}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-4 mx-3 sm:mx-5 bg-white rounded-md p-4 sm:p-5">
        <div className="flex flex-row justify-between items-center">
          <h3 className="text-sm text-black font-semibold">
            Advance Payment Request{" "}
          </h3>
          {!procuremntRead && (
            <button
              id="payment_request_advance_view_open_update_btn"
              className="text-white text-xs bg-green-500 rounded-md px-3 py-1.5"
              onClick={() => {
                getData(id);
                setShowCreatePaymentRequestModal(true);
              }}
            >
              Update
            </button>
          )}
        </div>
      </div>
      <form onSubmit={submit} className="px-3 sm:px-5 py-3">
        {/* <div className="flex items-center justify-between mb-2">
          <div className="text-xl font-bold border-l-4 border-myPrimaryColor pl-2">
            Advance Payment Request <span className="text-sm">#{data.id}</span>
          </div>
        </div> */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* PR Details Section */}
          <div className="flex flex-col gap-2 bg-white rounded-md p-4 sm:p-5 text-xs">
            <div className="flex flex-row justify-between items-center">
              <h3 className="text-sm text-black font-semibold">PR Details </h3>
            </div>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              <ReadField label="Percentage" value={data.percentage} />
              <ReadField
                label="PO No."
                value={data.po_no ? `#${data.po_no}` : undefined}
                valueClassName="text-blue-500"
              />
              <ReadField
                label="Amount"
                value={data.payment_amount}
                valueClassName="text-green-600"
              />
              <ReadField label="PI No." value={data.pi_no} />
              <ReadField label="Due date" value={fmtDate(data?.due_date)} />
              <ReadField label="PI Amount" value={data.pi_amount} />
              <ReadField label="Created On" value={fmtDate(data?.created_at)} />
              <ReadField label="PI date" value={fmtDate(data?.pi_date)} />
              <ReadField
                label="Requested By"
                value={data.created_by_name}
                className="col-span-2"
              />
            </div>
            <hr />
            <div className="flex flex-col">
              <span className="text-gray-400">Notes</span>
              <p className="font-semibold break-words text-gray-700 whitespace-pre-wrap">
                {data?.notes ? data.notes : "--"}
              </p>
            </div>
          </div>

          {/* Attachments Section */}
          <div className="flex flex-col gap-2 bg-white rounded-md p-4 sm:p-5 text-xs">
            <h3 className="text-sm text-black font-semibold">
              Attachments({data?.attachments?.length})
            </h3>
            <div className="flex flex-col gap-4">
              {/* Scrollable container for the attachment viewer */}
              <div className="max-h-96 overflow-y-auto border-2 rounded-md">
                <AttachmentViewer attachments={data?.attachments} />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="flex flex-col gap-2 my-5 bg-white rounded-md p-4 sm:p-5 text-xs">
            <div className="col-span-2 flex flex-col gap-2">
              <div className="">
                <label htmlFor="" className="text-sm text-black font-semibold ">
                  Project Details
                </label>{" "}
              </div>

              <div className=" text-xs mt-2">
                <div className="grid grid-cols-4">
                  <h5>Project name</h5>
                  <p className="col-span-3">: {defaultProject?.name || "--"}</p>
                </div>
                <div className="grid grid-cols-4">
                  <h5>Description</h5>
                  <p className="col-span-3">
                    : {defaultProject?.description || "--"}
                  </p>
                </div>
                <hr />
                <div className="grid grid-cols-4">
                  <h5>Amount :</h5>
                  <p className="col-span-3  text-right">
                    {currencyFormat(defaultProject?.totalBudget || 0)}
                  </p>
                </div>
                <div className="grid grid-cols-4">
                  <h5>Spent :</h5>
                  <p className="col-span-3  text-right">
                    {currencyFormat(defaultProject?.spent || 0)}
                  </p>
                </div>
                <hr />
                <div className="grid grid-cols-4">
                  <h5>Balance : </h5>
                  <p className="col-span-3 text-right">
                    {currencyFormat(
                      (defaultProject?.totalBudget || 0) -
                        (defaultProject?.spent || 0),
                    )}
                  </p>
                </div>

                <div className="flex gap-1 text-gray-500 text-xs mt-2 items-center">
                  <Icon path={mdiInformationOutline} size={0.8}></Icon>Note :
                  this balance is real-time ,Eg: if you create a po on x date
                  and balance is y then if you open the same po on z date
                  balance may be v.
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-col lg:flex-row justify-between lg:justify-between gap-2 my-5 bg-white rounded-md p-4 sm:p-5 text-xs">
            <div className="flex flex-col gap-2">
              <div>
                <h3 className="text-sm text-black font-semibold">
                  Vendor Details{" "}
                </h3>
              </div>
              <div className="flex flex-col gap-2">
                <ReadField label="Vendor" value={purchaseOrder?.party?.name} />
                <ReadField
                  label="Type"
                  value={purchaseOrder?.party?.type}
                  valueClassName="text-blue-500"
                />
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <div>
                <h3 className="text-sm text-black font-semibold">
                  Shipping Profile{" "}
                </h3>
              </div>
              <div className="flex flex-col gap-2">
                <ReadField
                  label="Address"
                  value={
                    purchaseOrder?.warehouse?.address?.city
                      ? `${purchaseOrder?.warehouse?.address?.city}, ${purchaseOrder?.warehouse?.address?.pincode}`
                      : undefined
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="px-0 sm:px-0 my-5">
          <h3 className="text-sm font-bold mb-2">Items</h3>
          {(() => {
            const isJobWork = purchaseOrder?.type === POType["Job Work PO"];
            return (
              <div className="mt-2 flex flex-col gap-3">
                {(purchaseOrder?.items || []).map((item) => (
                  <POLineItemCard
                    key={item.id}
                    variant={isJobWork ? "jobwork" : "regular"}
                    mode="view"
                    currency={purchaseOrder.vendor_currency}
                    data={item}
                    existingItems={existingItems}
                    onSubmit={() => {}}
                  />
                ))}
              </div>
            );
          })()}
        </div>
        <div className="my-5 bg-white p-4 sm:p-5 rounded-md text-xs">
          <div className="flex justify-between font-bold ">
            <p>Total</p>{" "}
            {console.log(
              "short hand",
              purchaseOrder?.vendor_currency?.short_name,
            )}
            <div className="">
              {/* {currencyFormat(purchaseOrder?.total ?? 0, purchaseOrder?.vendor_currency?.short_name ?? '')} */}
              {currencyFormat(
                purchaseOrder?.total ?? 0,
                purchaseOrder?.vendor_currency?.short_name || "INR",
              )}
            </div>
          </div>
          <hr />
          <div className="flex justify-between font-bold ">
            <p>Paid</p>{" "}
            <div className="">
              {currencyFormat(
                purchaseOrder?.paid ?? 0,
                purchaseOrder?.vendor_currency?.short_name || "INR",
              )}
            </div>
          </div>
          <hr />
          <div className="flex justify-between font-bold ">
            <p>Balance</p>{" "}
            <div className="">
              {currencyFormat(
                (purchaseOrder?.total ?? 0) - (purchaseOrder?.paid || 0),
                purchaseOrder?.vendor_currency.short_name || "INR",
              )}
            </div>
          </div>
        </div>
        {/* {data.pr_status !== po_payments_req_status.withdrawn && (
          <div className="flex gap-4 justify-end px-5">
            <button
              onClick={() => {
                setShowAdvancePaymentRequestWithdrawModal(true);
                setData({
                  ...data,
                  pr_status: po_payments_req_status.withdrawn,
                });
              }}
              className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
            >
              Withdrawn
            </button>
          </div>
        )} */}
        {/* Assuming you have a LoadingWidget component */}
      </form>

      {loading && <LoadingWidget />}
    </>
  );
};

export default PaymentRequestAdvanceScreen;
